export interface HeroSlide {
  id: string;
  image: string;
  eyebrow: string;
  title: string;
  highlight: string;
  description: string;
  chapterId: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "hero-01",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20elegant%20interior%20with%20heavy%20wine%20red%20velvet%20curtains%2C%20antique%20gold%20lamp%20glow%2C%20empty%20chair%20and%20a%20mahjong%20table%2C%20volumetric%20light%20beams%20and%20smoke%2C%20film%20noir%20atmosphere%2C%20rich%20burgundy%20and%20brass%20palette%2C%20dramatic%20wide%20composition%2C%20no%20text&width=1920&height=960&seq=sj-hero-01&orientation=landscape",
    eyebrow: "高清剧情档案 · 完整章节",
    title: "色戒",
    highlight: "无删减版",
    description:
      "一场以演戏开始的靠近，最后谁也没能全身而退。十二个章节，重新梳理那段被雨水与谎言包裹的故事。",
    chapterId: "chapter-01",
  },
  {
    id: "hero-02",
    image:
      "https://readdy.ai/api/search-image?query=rainy%20night%20city%20street%20with%20wet%20stone%20paving%20reflecting%20amber%20street%20lamps%2C%20vintage%20sedan%20silhouette%2C%20deep%20crimson%20and%20gold%20light%20haze%2C%20moody%20historical%20film%20noir%20scene%2C%20cinematic%20wide%20angle%2C%20no%20text&width=1920&height=960&seq=sj-hero-02&orientation=landscape",
    eyebrow: "剧情时间线 · 逐步解读",
    title: "从牌桌到",
    highlight: "最后一颗钻石",
    description:
      "按时间线拆解每一场关键戏：试探、动摇、越界与抉择。你可以从任意章节进入，也可以按顺序完整重看一遍。",
    chapterId: "chapter-04",
  },
  {
    id: "hero-03",
    image:
      "https://readdy.ai/api/search-image?query=soft%20window%20light%20through%20sheer%20curtains%20in%20an%20old%20apartment%2C%20dust%20particles%20in%20golden%20beams%2C%20deep%20wine%20red%20wall%20and%20antique%20furniture%20silhouettes%2C%20melancholic%20cinematic%20interior%2C%20warm%20amber%20palette%2C%20no%20text&width=1920&height=960&seq=sj-hero-03&orientation=landscape",
    eyebrow: "深度专题 · 影评与幕后",
    title: "把没说出口的",
    highlight: "都写下来",
    description:
      "六篇长文，聊戒指的隐喻、牌桌上的权力流转、旗袍与雨夜的时代质感，以及那个改变一切的选择。",
    chapterId: "chapter-08",
  },
];